var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "ring-icon-permission",
  "use": "ring-icon-permission-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"ring-icon-permission\"><path d=\"M15.466 4.095l-1.162-1.163 1.002-1.001a.557.557 0 0 0 0-.788l-.98-.98a.557.557 0 0 0-.788 0L7.09 6.611a4.78 4.78 0 0 0-2.247-.58 4.843 4.843 0 1 0 4.843 4.844 4.8 4.8 0 0 0-.754-2.57l2.582-2.583 1.204 1.204a.75.75 0 1 0 1.06-1.06L12.576 4.66l.668-.668 1.163 1.162a.75.75 0 1 0 1.06-1.06zM4.843 14.218a3.343 3.343 0 1 1 3.343-3.343 3.347 3.347 0 0 1-3.343 3.343z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id